<div class="login-screen">

    <app-vormen></app-vormen>

    <!-- Login card -->
    <div class="login-card">

        <!-- Logo -->
        <div class="brand-logo">
            <img src="assets/img/logo.svg" alt="OpStoom" class="logo-img" />
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSignIn()" autocomplete="on">

            <!-- Username -->
            <div class="form-group">
                <input
                    id="username"
                    formControlName="username"
                    class="form-control"
                    type="text"
                    autocomplete="username"
                    placeholder="{{ 'login.username' | translate }}"
                />
                <messages
                    class="field-error"
                    [form]="loginForm"
                    [messagesObserver]="messages"
                    fieldname="username">
                </messages>
            </div>

            <!-- Password -->
            <div class="form-group">
                <input
                    id="password"
                    formControlName="password"
                    class="form-control"
                    type="password"
                    autocomplete="current-password"
                    placeholder="{{ 'login.password' | translate }}"
                />
                <messages
                    class="field-error"
                    [form]="loginForm"
                    [messagesObserver]="messages"
                    fieldname="password">
                </messages>
            </div>

            <!-- General / non-field errors (wrong credentials etc.) -->
            <messages
                class="general-error"
                [form]="loginForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="FALSE"
                [showFieldKeys]="FALSE">
            </messages>

            <!-- Login button -->
            <div class="button-container">
                <action-button
                    class="btn-login"
                    (actionEvent)="onSignIn($event)"
                    label="{{ buttonLabel | translate }}">
                </action-button>
            </div>

            <!-- Forgot password -->
            <a class="forgot-password-link" (click)="navigateToForgotPassword()">
                {{ "login.forgotPassword" | translate }}
            </a>

        </form>
    </div>
</div>
